import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import {
  mapPunchoutOrderGuideItem,
  PunchoutOrderGuideApiItem,
  PunchoutOrderGuideItem,
} from 'src/types/punchout-order-guide/PunchoutOrderGuideItem';
import axiosInstance from 'src/utils/axios';

const useGetPunchoutOrderGuideQuery = (
  catalogId: number | null,
  enabled = true
): UseQueryResult<PunchoutOrderGuideItem[]> =>
  useQuery<PunchoutOrderGuideItem[]>({
    queryKey: queryKeys.product.punchoutOrderGuide(catalogId),
    queryFn: async (): Promise<PunchoutOrderGuideItem[]> => {
      if (catalogId == null) {
        throw new Error('catalogId is required');
      }

      const res = await axiosInstance.get<PunchoutOrderGuideApiItem[]>(
        api.getPunchoutOrderGuide(catalogId)
      );
      return (res.data ?? []).map(mapPunchoutOrderGuideItem);
    },
    enabled: enabled && catalogId !== null,
  });

export default useGetPunchoutOrderGuideQuery;
